import { ComponentType } from 'react';
import { compose, mapProps, withHandlers, withState } from 'recompose';

import withAppMeta, { WithAppMetaProps } from '../../../../../HOCs/withAppMeta';
import withAuth, { WithAuth } from '../../../../../HOCs/withAuth';
import { PositionProps } from '../../../../../HOCs/withPosition';
import { SubmitFormFields } from '../../../SubmitForm';

import withSignUpStepPosition, {
  EMAIL_AUTH_VIEW,
  SOCIAL_EMAIL_VIEW,
  UPDATE_USER_VIEW
} from './withSignUpStepPosition';

type HOCs = WithAuth & WithAppMetaProps & PositionProps;
type Handlers = {
  handleSignUpEmailClick: () => void;
  handleEmailAuthSubmit: (emailAuthFields: SubmitFormFields) => void;
  handleBackClick: () => void;
};

export type StepViewPosition =
  | typeof SOCIAL_EMAIL_VIEW
  | typeof EMAIL_AUTH_VIEW
  | typeof UPDATE_USER_VIEW;

export type WithSignUpStepsHandlersProps = Handlers &
  HOCs &
  WithSignUpStepsHandlersOwnProps;

export type WithSignUpStepsHandlersOwnProps = {
  onStepChange: (step: StepViewPosition) => void;
};

export default <P>(
  BaseComponent: ComponentType<WithSignUpStepsHandlersProps & P>
) => {
  type BaseComponentOwnProps = Pick<
    P,
    Exclude<keyof P, keyof WithSignUpStepsHandlersProps>
  > &
    WithSignUpStepsHandlersOwnProps;

  return compose<WithSignUpStepsHandlersProps & P, BaseComponentOwnProps>(
    withAuth,
    withAppMeta,
    withSignUpStepPosition,
    withState('currentStep', 'onStepChange', SOCIAL_EMAIL_VIEW),
    mapProps<WithSignUpStepsHandlersProps, WithSignUpStepsHandlersProps>(
      ({ position, onStepChange, ...other }) => ({
        ...other,
        position,
        onStepChange: step => {
          position.next(step);
          onStepChange(step);
        }
      })
    ),
    withHandlers<WithSignUpStepsHandlersProps, Handlers>({
      handleSignUpEmailClick: ({ onStepChange }) => () =>
        onStepChange(EMAIL_AUTH_VIEW),
      handleEmailAuthSubmit: ({ signup, appMeta: { entry, product } }) => (
        emailAuthFields: SubmitFormFields
      ) => {
        signup({
          ...emailAuthFields,
          entry,
          product,
          type: 'EMAIL'
        });
      },
      handleBackClick: ({ onStepChange }) => () =>
        onStepChange(SOCIAL_EMAIL_VIEW)
    })
  )(BaseComponent);
};
